import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Spinner } from "react-bootstrap";
import { FaTrash, FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import api from "../services/api";

const JobWorkerList = () => {
  const [search, setSearch] = useState("");
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchWorkers();
  }, []);

  const fetchWorkers = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.post("/job_worker_list.php", {});
      
      if (response.data.head.code === 200) {
        const transformedData = response.data.body.map(jobWorker => ({
          id: jobWorker.id,
          name: jobWorker.name,
          mobile: jobWorker.mobile,
          gst_number: jobWorker.address,
          city: jobWorker.city,
          pin_code: jobWorker.pincode
        }));
        
        setWorkers(transformedData);
      } else {
        setError(response.data.head.msg || "Failed to fetch suppliers");
      }
    } catch (err) {
      console.error("Error fetching workers:", err);
      setError("Failed to load job workers. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Are you sure you want to delete ${name}?`)) {
      return;
    }

    try {
      const response = await api.post("/job_worker_delete.php", { id });
      
      if (response.data.head.code === 200) {
        setWorkers(workers.filter((s) => s.id !== id));
        alert("Worker deleted successfully!");
      } else {
        alert("Failed to delete Worker: " + response.data.head.msg);
      }
    } catch (err) {
      console.error("Error deleting Worker:", err);
      alert("Failed to delete Worker. Please try again.");
    }
  };

  const filteredWorkers = workers.filter((worker) => {
    if (!search) return true;
    const query = search.toLowerCase();
    return (
      String(worker.id).toLowerCase().includes(query) ||
      (worker.name && worker.name.toLowerCase().includes(query)) ||
      (worker.city && worker.city.toLowerCase().includes(query)) ||
      (worker.mobile && worker.mobile.includes(query))
    );
  });

  const {
    currentPage,
    totalPages,
    currentItems: currentWorkers,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(filteredWorkers, 10);

  if (loading) {
    return (
      <Container fluid className="outer-container my-3">
        <h2 className="text-center mb-3">Job Worker Management</h2>
        <div className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading job workers...</p>
        </div>
      </Container>
    );
  }
{/* 
  if (error) {
    return (
      <Container fluid className="outer-container my-3">
        <h2 className="text-center mb-3">Job Worker Management</h2>
        <div className="alert alert-danger" role="alert">
          {error}
          <button className="btn btn-sm btn-outline-danger ms-3" onClick={fetchWorkers}>
            Retry
          </button>
        </div>
      </Container>
    );
  }
*/}
  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Job Worker Management</h2>
      
      <Row className="mb-3 align-items-center">
        <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
          <Form.Control
            placeholder="Search by name, mobile"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>

        <Col xs={12} md={6} lg={8} className="d-flex justify-content-md-end">
          <Link
            to="/addjobworker"
            className="btn-top d-inline-flex align-items-center"
          >
            <FaPlus className="me-2" /> Add Job Worker
          </Link>
        </Col>
      </Row>

      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Worker Name</th>
                <th>Mobile</th>
                {/* <th>City</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentWorkers.map((worker, index) => (
                <tr key={worker.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>
                    <Link 
                      to={`/viewjobworker/${worker.id}`}
                      className="text-decoration-none"
                    >
                      {worker.name}
                    </Link>
                  </td>
                  <td>{worker.mobile}</td>
                  {/* <td>{worker.city}</td> */}
                  <td>
                    <div className="action-icons">
                      {/* <Link
                        to={`/viewjobworker/${worker.id}`}
                        className="me-2"
                        title="View Details"
                      >
                        <FaEye className="view-icon" />
                      </Link> */}
                      <Link
                        to={`/editjobworker/${worker.id}`}
                        className="me-2"
                        title="Edit Job Worker"
                      >
                        <FaEdit className="edit-icon" />
                      </Link>
                      <FaTrash
                        className="delete-icon"
                        title="Delete Job Worker"
                        onClick={() => handleDelete(worker.id, worker.name)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {currentWorkers.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center">
                    {search ? "No job workers found matching your search" : "No job workers found"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default JobWorkerList;